var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyDataBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 14.6002L16.8 14.6002V17.0002H19.2M19.2 9.80019L16.8 9.80019V12.2002L19.2 12.2002M21.6 19.4002H12L12 17.0002H14.4V14.6002H12V12.2002H14.4L14.4 9.80019H12V7.4002L21.6 7.4002M9.6 5.0002L7.2 5.0002V2.6002L9.6 2.6002M9.6 9.80019H7.2L7.2 7.4002L9.6 7.4002M9.6 14.6002H7.2L7.2 12.2002H9.6M9.6 19.4002L7.2 19.4002V17.0002L9.6 17.0002M4.8 5.0002H2.4L2.4 2.6002L4.8 2.6002M4.8 9.80019L2.4 9.80019L2.4 7.4002H4.8M4.8 14.6002L2.4 14.6002L2.4 12.2002L4.8 12.2002M4.8 19.4002H2.4L2.4 17.0002H4.8M12 5.0002L12 0.200195L0 0.200195L0 21.8002L24 21.8002L24 5.0002L12 5.0002Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyDataBlack);
export default __webpack_public_path__ + "static/media/company-data-black.0401604ebe5f2bbf7b75cc3be82fdf18.svg";
export { ForwardRef as ReactComponent };